import { Outlet } from "react-router-dom";
import { AuthProvider } from "./context/context.authentication.tsx";
import { SWRConfig } from "swr";
import { ThemeProvider } from "./context/context.theme";

import { CompactProvider } from "./context/context.compact";
import { PageSizeProvider } from "./context/context.page.tsx";
import { CookieProvider } from "./context/context.cookie.tsx";
import Hanger from "./components/navigation/header/Hanger.tsx";
import Dock from "./components/navigation/dock/Dock.tsx";
import CookieNotice from "./components/core/cookie/CookieNotice.tsx";
import { ReactElement } from "react";
import InstallNotice from "./components/core/install/InstallNotice.tsx";
import ErrorBoundary from "./components/core/ErrorBoundary.tsx";

export default function App(): ReactElement {
  if ("serviceWorker" in navigator) {
    window.addEventListener("load", () => {
      navigator.serviceWorker
        .register("/service-worker.js")
        .then((registration) => {
          console.log("ServiceWorker registered:", registration.scope);
        })
        .catch((err) => {
          console.log("ServiceWorker registration failed:", err);
        });
    });
  }
  return (
    <ErrorBoundary>
      <SWRConfig>
        <AuthProvider>
          <ThemeProvider>
            <CompactProvider>
              <PageSizeProvider>
                <Hanger />
                <Dock />
                <Outlet />
              </PageSizeProvider>
            </CompactProvider>
            <CookieProvider>
              <CookieNotice />
              <InstallNotice />
            </CookieProvider>
          </ThemeProvider>
        </AuthProvider>
      </SWRConfig>
    </ErrorBoundary>
  );
}
